import { render, staticRenderFns } from "./DynamicDetail.vue?vue&type=template&id=35f4cf34&scoped=true"
import script from "./DynamicDetail.vue?vue&type=script&lang=js"
export * from "./DynamicDetail.vue?vue&type=script&lang=js"
import style0 from "./DynamicDetail.vue?vue&type=style&index=0&id=35f4cf34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f4cf34",
  null
  
)

export default component.exports